<!-- ==================== APP CONTAINER ==================== -->
<div class="app-container">
    @if (environmentName !== 'production') {
        <div class="environment-indicator">
            {{ environmentName | uppercase }}
        </div>
    }

    <!-- ==================== MAIN CONTENT ==================== -->

    @if (isLoading()) {
        <div class="loading-layout">
            <p-progressSpinner />
        </div>
    } @else {
        @if (isAuthenticated()) {
            <div class="app-layout">
                <app-top-banner></app-top-banner>
                <app-header />
                <main class="app-content">
                    <router-outlet />
                </main>
                <app-footer />
            </div>
        } @else {
            <div class="login-layout">
                <router-outlet />
            </div>
        }
    }
</div>

<!-- ==================== GLOBAL TOAST ==================== -->
<p-toast></p-toast>

<!-- ==================== GLOBAL CONFIRM DIALOG ==================== -->
<p-confirmDialog [dismissableMask]="true" [draggable]="false" />
